import React from 'react';
import { fetchTradingEventSeason } from 'src/redux/actions';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { TradingQuestType } from 'src/utils/types';
let fetchSeasonPromise;
export const checkValid = (configQuest, heroInfo) => {
  const {
    heroClass,
    heroLevel,
    heroTrophyClass,
    skinRarity
  } = configQuest;

  if (heroClass === undefined && heroLevel === undefined && heroTrophyClass === undefined && skinRarity === undefined) {
    return false;
  }

  if (heroInfo.heroTrophyClass === undefined && heroInfo.heroLevel === undefined && heroInfo.heroTrophyClass === undefined && heroInfo.skinRarity === undefined) {
    return false;
  }

  return (heroTrophyClass === undefined || heroInfo.heroTrophyClass == undefined || heroInfo.heroTrophyClass >= heroTrophyClass) && (heroLevel === undefined || heroInfo.heroLevel == undefined || heroInfo.heroLevel >= heroLevel) && (heroClass == undefined || heroInfo.heroClass == undefined || heroInfo.heroClass === heroClass) && (skinRarity == undefined || heroInfo.skinRarity == undefined || heroInfo.skinRarity === skinRarity);
};

function useCheckTradingEvent(props) {
  const quest = useTypedSelector(state => {
    var _state$tradingEventSe;

    return (_state$tradingEventSe = state.tradingEventSeason.data) === null || _state$tradingEventSe === void 0 ? void 0 : _state$tradingEventSe.quest;
  });
  const {
    startTime = 0,
    endTime = 0
  } = useTypedSelector(state => state.tradingEventSeason.data) || {};
  const version = useTypedSelector(state => {
    var _state$tradingEventSe2;

    return (_state$tradingEventSe2 = state.tradingEventSeason.config) === null || _state$tradingEventSe2 === void 0 ? void 0 : _state$tradingEventSe2.version;
  });
  const dispatch = useTypedDispatch();
  React.useEffect(() => {
    if (!quest) {
      const init = async () => {
        // This condition just makes an dispatch action one times
        if (fetchSeasonPromise) {
          await fetchSeasonPromise;
          fetchSeasonPromise = undefined;
        } else {
          await (fetchSeasonPromise = new Promise(resolve => {
            resolve(dispatch(fetchTradingEventSeason(-1)));
          }));
        }
      };

      init();
    }
  }, [dispatch, quest, version]);

  if (!quest) {
    return {
      hasEvent: false,
      heroEvent: false
    };
  }

  const {
    type,
    heroClass,
    heroLevel,
    heroTrophyClass,
    skinRarity
  } = quest;
  const now = Date.now();
  return {
    hasEvent: startTime <= now && endTime > now,
    heroEvent: type === TradingQuestType.ALL_HERO ? true : checkValid({
      heroClass,
      heroLevel,
      heroTrophyClass,
      skinRarity
    }, props)
  };
}

export default useCheckTradingEvent;